import { render, staticRenderFns } from "./InputCurrencyField.vue?vue&type=template&id=57b651d3"
import script from "./InputCurrencyField.vue?vue&type=script&lang=js"
export * from "./InputCurrencyField.vue?vue&type=script&lang=js"
import style0 from "./InputCurrencyField.vue?vue&type=style&index=0&id=57b651d3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports